import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessagesModule } from 'primeng/messages';
import { PlockapiService } from '../../../services/plockapi.service';
import { Device } from '../../Models/device';
import { Message } from 'primeng/api';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-devicelist',
  standalone: true,
  imports: [ListboxModule, FormsModule, ProgressBarModule, CommonModule, PanelModule, MessagesModule],
  templateUrl: './devicelist.component.html',
  styleUrl: './devicelist.component.css'
})
export class DevicelistComponent implements OnInit {

  devices: any[] = [];
  loadingDevices: boolean = true;
  selectedDevice: any;
  devicesDataset: Device[] = [];
  messages: Message[] = []
  errorMessage?: string;
  isServerError: boolean = false;
  @Output() device: EventEmitter<any> = new EventEmitter();

  constructor(private _service: PlockapiService, private _storage: StorageService) {
    //MOCK DEVICES
    // this.devices = [
    //   { name: 'PLK40000', code: '1' },
    //   { name: 'PLK06000', code: '2' },
    //   { name: 'PLK00100', code: '3' },
    //   { name: 'PLK40100', code: '4' },
    //   { name: 'PLK00120', code: '5' },
    //   { name: 'PLK40122', code: '6' },
    //   { name: 'PLK06002', code: '7' },
    // ];
  }

  ngOnInit(): void {
    let user = this._storage.getStoredUser();
    this._service.getRinhoDevices(user.Username).subscribe({
      next: res => {
        this.devicesDataset = res;
        this.fillDeviceDisplayList(this.devicesDataset);
        this.loadingDevices = false;
      },
      error: err => {
        this.loadingDevices = false;
        this.isServerError = true;
        this.messages.push({ severity: 'error', summary: "El servidor no responde. Vuelva a intentar en breve." })
      }
    });
  }

  notifyChange() {
    this.device.emit(this.selectedDevice);
  }

  fillDeviceDisplayList(list: Device[]): void {
    if(list && list.length > 0)
      list.forEach(d => this.devices.push({ name: d.NroSerie, code: d.Id }));
  }
}
